import React, { useState,useEffect } from "react";
import { Container,CircularProgress, Grid, FormControl, Card, CardMedia, Select, Menu, MenuItem, CardContent, Typography, Button, Box, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Banner from '../../../src/assets/GiftAsset/banner.svg';
import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import ResponsiveNav from "../ptwopproduct/navbar";
import Arrowup from "../../assets/GiftAsset/arrowup.svg"; 



const ProductGrid = () => {

const [products, setProducts] = useState([]);
 // eslint-disable-next-line no-unused-vars
 const [anchorEl, setAnchorEl] = useState(null);
 const [selectedProduct, setSelectedProduct] = useState(null);
 const [selectedStatus, setSelectedStatus] = useState("All");
 const [filteredProducts, setFilteredProducts] = useState([]);
 const [searchTerm, setSearchTerm] = useState("");
 const [loading, setLoading] = useState(true); 

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
 const navigate = useNavigate();


 const handleEditProducts = (product) => {
  if (!product) {
    console.error("Product is null or undefined!");
    return;
  }

  if (!product.productId) {
    console.error("Missing productId in product:", product);
    return;
  }

  navigate(`/product/edit/${product.productId}`);
 
};

 
 const handleEditProduct = () => {
  if (!selectedProduct) {
    console.error("selectedProduct is null or undefined!");
    return;
  }

  if (!selectedProduct.productId) {
    console.error("Missing productId in selectedProduct:", selectedProduct);
    return;
  }

  navigate(`/product/edit/${selectedProduct.productId}`);
  handleMenuClose();
};

const handlePromoteProduct = () => {
  if (!selectedProduct) {
    console.error("selectedProduct is null or undefined!");
    return;
  }

  if (!selectedProduct.productId) {
    console.error("Missing productId in selectedProduct:", selectedProduct);
    return;
  }

  // If the productId is valid, proceed
  navigate(`/product/promote/${selectedProduct.productId}`);
  handleMenuClose();
};

const handleDeleteProduct = () => {
  if (!selectedProduct) {
    console.error("selectedProduct is null or undefined!");
    return;
  }

  if (!selectedProduct.productId) {
    console.error("Missing productId in selectedProduct:", selectedProduct);
    return;
  }

  // If the productId is valid, proceed
  navigate(`/product/delete/${selectedProduct.productId}`);
  handleMenuClose();
};



 const handleMenuClose = () => {
   setAnchorEl(null);
   setSelectedProduct(null);
 };








 useEffect(() => {
  console.log("Component mounted");

  const fetchProducts = async () => {
    console.log("Fetching products...");
    setLoading(true);

    const token = localStorage.getItem("token");
    const storedEmail = sessionStorage.getItem("userEmail");

    if (!token || !storedEmail) {
      console.error("Token or User email is missing. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const encodedEmail = encodeURIComponent(storedEmail);
      const apiUrl = `https://daradservice.azurewebsites.net/api/P2PProducts/my-P2Pproducts?userEmail=${encodedEmail}`;

      console.log("Fetching from:", apiUrl);

      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

     
      const productsData = data?.result?.data || data.data;

      if (data.status && Array.isArray(productsData)) {
        setProducts(productsData);
        setFilteredProducts(productsData);
      } else {
        console.error("Unexpected API response format:", data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchProducts();
}, []); 




useEffect(() => {
  if (!products.length) return;

  const filtered = products.filter((product) => {
    if (selectedStatus === "All") return true;
    if (selectedStatus === "Active") return product.promotionStatus?.toLowerCase() === "active";
    if (selectedStatus === "Promoted") return product.promotionStatus?.toLowerCase() === "promoted";
    if (selectedStatus === "Expired") return product.promotionStatus?.toLowerCase() === "expired";
    return false;
  });

  setFilteredProducts(filtered);
}, [products, selectedStatus]);  


const handleMenuOpen = (event, product) => {
  event.stopPropagation();
  if (product) {
    setAnchorEl(event.currentTarget);
    setSelectedProduct(product);
   
  }
};





  


const breadcrumbItems = [
  { label: "Home", link: "/" },
  { label: "My P2P Products", link: "/product/ptwop" },
];

  
  const handleSearchChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    // Filter products by title or description
    const filtered = products.filter(
      (product) =>
        product.title.toLowerCase().includes(query) ||
        product.description.toLowerCase().includes(query)
    );

    setFilteredProducts(filtered);
  };






  

  


  
  
 
  
  

  return (
     <Container maxWidth={isDesktop ? "lg" : "sm"} sx={{ py: 4, px: 2 }}>
     {/* Heading */}

     <ResponsiveNav
        searchValue={searchTerm}
        onSearchChange={handleSearchChange}
        searchPlaceholder="Search for products by name, category,...."
        breadcrumbItems={breadcrumbItems}
      />
      
      <Box
       sx={{
        borderBottom: "1px solid #ccc",
        mt: isDesktop ? "20px" : "20px",
      }}>  
      <Box
  sx={{
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    justifyContent: "space-between",
    alignItems: isDesktop ? "center" : "flex-start",
    textAlign: isDesktop ? "left" : "center",
    gap: isDesktop ? 0 : "16px",
  }}
>
  {/* Heading */}
  <Box sx={{ width: isDesktop ? "auto" : "100%" }}>
    <Typography
      variant="h4"
      fontWeight={700}
      color="#5604F6"
      gutterBottom
      sx={{ fontSize: isDesktop ? "36px" : "28px" }}
    >
      Your P2P Product 
    </Typography>
 
  </Box>

  {/* Button */}
  <Link
  to="/product/post_a_product"
  style={{ textDecoration: "none", width: isDesktop ? "auto" : "100%" }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: isDesktop ? "300px" : "100%",
      height: "60px",
      cursor: "pointer",
      border: "2px solid #EEE6FE",
      borderRadius: "9999px",
      padding: "8px",
      color: { xs: "white", md: theme.palette.secondary.main }, 
      backgroundColor: { xs: theme.palette.secondary.main, md: "transparent" }, 
    }}
  >
    <Typography
      variant="h6"
      sx={{
        ...theme.typography.urbanist600,
        fontSize: isDesktop ? "24px" : "20px",
        color: { xs: "white", md: theme.palette.secondary.main }, 
      }}
      component="span"
    >
      Post New Product
    </Typography>
  </Box>
</Link>

</Box>
<Typography
     sx={{
                      
      fontSize: "18px",
      ...theme.typography.Inter500,
      mt:"20px"
    }} >
      Explore, manage, and promote your peer-to-peer product listings with ease.
    </Typography>

</Box>

   




<Box sx={{ display: "flex", alignItems: "center", gap: 0.5, m: 4, justifyContent: "flex-end" }}>
  <Typography variant="h6" sx={{ fontSize: 16, whiteSpace: "nowrap" }}>
    All Product Status
  </Typography>
  <FormControl sx={{ minWidth: 120 }}>
    <Select
      value={selectedStatus}
      onChange={(event) => setSelectedStatus(event.target.value)}
      displayEmpty
      sx={{
        height: 32,
        fontSize: 14,
        paddingX: 1,
        boxShadow: "none",
        "& fieldset": { border: "none" }, // Removes the border
      }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="Active">Active</MenuItem>
      <MenuItem value="Promoted">Promoted</MenuItem>
      <MenuItem value="Expired">Expired</MenuItem>
    </Select>
  </FormControl>
</Box>




      {/* Products Grid */}
      
      <Grid container spacing={isDesktop ? 6 : 3} rowSpacing={isDesktop ? 4 : 2}>
        {loading ? (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
              <CircularProgress />
            </Box>
       ) : Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
          
          filteredProducts.map((product, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={product.id || index}>
          
            <Card sx={{ position: "relative" }}>
              {/* More Icon Button */}
              <IconButton
              onClick={(event) => {
                event.stopPropagation(); 
                handleMenuOpen(event, product);
              }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "gray",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  borderRadius: "50%",
                  zIndex: 2,
                }}
              >
                <MoreVertIcon />
              </IconButton>

              {/* Product Image with "PROMOTED" Badge */}
              <Box
  onClick={() => {
    setSelectedProduct(product);
    handleEditProduct();
  }}
  sx={{
    cursor: "pointer", position: "relative" }}>
              {product.videoPath ? (  // Ensure the correct key is used
          <video
            src={product.videoPath}
            controls
            autoPlay
            loop
            muted
            style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "8px" }}
          />
        ) : (
          <CardMedia
            component="img"
            image={product.imagePath || "default-image.jpg"}
            alt={product.title}
            sx={{ height: 200, objectFit: "cover" }}
          />
        )}


                {product.promotionStatus === "Active" && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "24px",
                      backgroundColor: "#F6A704",
                      color: "black",
                      fontWeight: "bold",
                      padding: "8px 10px",
                      borderRadius: "4px",
                      fontSize: "20px",
                    }}
                  >
                    Promoted
                  </Box>
                )}
              </Box>

              <CardContent>
  <Typography variant="h6" sx={{ ...theme.typography.urbanist700, fontSize: isDesktop ? "28px" : "26px" }}>
    {product.title}
  </Typography>
  <Typography 
  variant="body2" 
  sx={{ ...theme.typography.Inter500, fontSize: "16px" }} 
  color="textSecondary" 
  mb={1}
>
  {product.description.length > 50 
    ? `${product.description.substring(0, 50)}...` 
    : product.description}
</Typography>

   <Typography 
                   sx={{ 
                     ...theme.typography.urbanist800, 
                     fontSize: "32px", 
                     color: "#F6A704" 
                   }}
                 >
                   ₦{new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 }).format(product.price)}
                 </Typography>

  <Box display="flex" alignItems="center" mt={1}>
    <LocationOnIcon fontSize="small" color="action" />
    <Typography variant="body2" sx={{ ...theme.typography.Inter400, fontSize: "16px" }} color="textSecondary" ml={0.5}>
      {product.location}
    </Typography>
  </Box>

  {/* Centering the Button */}
  <Box display="flex" justifyContent="center" width="100%" mt={2}>
  {product.availability === "Expired" ? (
    <Button
      sx={{
        bgcolor: "#5604F6",
        color: "white",
        gap: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "9999px",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        ...theme.typography.urbanist600,
        padding: { xs: "6px 12px", sm: "10px 20px", md: "12px 24px" },
        textTransform: "none",
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          bgcolor: "#03A662",
        },
      }}
      onClick={() => handleEditProducts(product)}
      >
        Renew Product
        <ArrowForwardIosIcon fontSize="small" sx={{ ml: 1 }} />
     
    </Button>
  ) : (
    <Button
      sx={{
        bgcolor: "#5604F6",
        color: "white",
        gap: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "9999px",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        ...theme.typography.urbanist600,
        padding: { xs: "6px 12px", sm: "10px 20px", md: "12px 24px" },
        textTransform: "none",
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          bgcolor: "#4503D6",
        },
      }}
      onClick={() => handleEditProducts(product)}
    >
      Active
    </Button>
  )}
</Box>

</CardContent>

            </Card>
         
          </Grid>
        ))
      ) : (
        <Typography variant="body1" color="textSecondary" sx={{ m: 2 }}>
          No products found.
        </Typography>
      )}

      {/* Menu Modal */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
  <MenuItem onClick={handleEditProduct}>Edit Product</MenuItem>
  <MenuItem onClick={handlePromoteProduct}>Promote Product</MenuItem>
  <MenuItem
   onClick={handleDeleteProduct}
  >
    Delete Product
  </MenuItem>
</Menu>;
    </Grid>




<Box
  sx={{
    position: "relative",
    width: "100%", 
    margin: isDesktop ? "0" : "0 auto", 
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      borderRadius: "12px",
      p: isDesktop ? "36px" : "20px",
      mt: isDesktop ? "160px" : "80px",
      background: "linear-gradient(to right, #E7E1D3, #1C1B17)",
      color: "black",
      width: "100%", // Keep width inside the container full
      minHeight: "250px",
      textAlign: isDesktop ? "left" : "center",
    }}
  >
    {/* Left Content - 70% Width */}
    <Box sx={{ flexBasis: isDesktop ? "70%" : "100%", mb: isDesktop ? 0 : "20px" }}>
      <Typography
        sx={{
          ...theme.typography.urbanist700,
          fontSize: isDesktop ? "48px" : "32px",
        }}
      >
        Turn Your Listings <br /> into Bestsellers
      </Typography>
      <Typography
        variant="body1"
        sx={{
          ...theme.typography.Inter400,
          fontSize: isDesktop ? "20px" : "16px",
          mt: "20px",
        }}
        color="textSecondary"
      >
        Promote your products to stay on top and attract more buyers instantly.
      </Typography>

      {/* Promote Product Button */}
      <Button
        variant="contained"
        sx={{
          mt: 2,
          bgcolor: "#5604F6",
          color: "white",
          textTransform: "none",
          borderRadius: "9999px",
          ...theme.typography.urbanist600,
          padding: "10px 24px",
          "&:hover": { bgcolor: "#4503D6" },
          gap: 1,
        }}
      >
        Promote Product
        <img src={Arrowup} alt="No Products" width={10} height={10} />
      </Button>
    </Box>

    {/* Right Section - 30% Width */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Image */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "50%" },
          textAlign: "center",
        }}
      >
        <img
          src={Banner}
          alt="Promotion"
          style={{ width: "100%", height: "auto", borderRadius: "8px" }}
        />
      </Box>

      {/* Button */}
      <Button
        variant="contained"
        sx={{
          bgcolor: "white",
          color: "#5604F6",
          textTransform: "none",
          borderRadius: "9999px",
          width: { xs: "auto", md: "300px" },
          height: "50px",
          px: 2,
          py: 1,
          fontSize: { xs: "12px", md: "16px" },
          ...theme.typography.urbanist600,
          "&:hover": { bgcolor: "#f0f0f0" },
        }}
      >
        Boost Now for Just ₦500/Day
      </Button>
    </Box>
  </Box>
</Box>




      
{/* Discounted Products Section */}
<Typography variant="h5" fontWeight={600} mt={6} mb={2}>
  Discounted P2P Products
</Typography>

<Grid container spacing={isDesktop ? 6 : 3} rowSpacing={isDesktop ? 4 : 2}>
        {loading ? (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
              <CircularProgress />
            </Box>
       ) : Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
          
          filteredProducts.map((product, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={product.id || index}>
          
            <Card sx={{ position: "relative" }}>
              {/* More Icon Button */}
              <IconButton
              onClick={(event) => {
                event.stopPropagation(); 
                handleMenuOpen(event, product);
              }}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "gray",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  borderRadius: "50%",
                  zIndex: 2,
                }}
              >
                <MoreVertIcon />
              </IconButton>

              {/* Product Image with "PROMOTED" Badge */}
              <Box sx={{ position: "relative" }}>
              {product.videoPath ? (  // Ensure the correct key is used
          <video
            src={product.videoPath}
            controls
            autoPlay
            loop
            muted
            style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "8px" }}
          />
        ) : (
          <CardMedia
            component="img"
            image={product.imagePath || "default-image.jpg"}
            alt={product.title}
            sx={{ height: 200, objectFit: "cover" }}
          />
        )}


                {product.promotionStatus === "Active" && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "24px",
                      backgroundColor: "#F6A704",
                      color: "black",
                      fontWeight: "bold",
                      padding: "8px 10px",
                      borderRadius: "4px",
                      fontSize: "20px",
                    }}
                  >
                    Promoted
                  </Box>
                )}
              </Box>

              <CardContent>
  <Typography variant="h6" sx={{ ...theme.typography.urbanist700, fontSize: isDesktop ? "28px" : "26px" }}>
    {product.title}
  </Typography>
  <Typography 
  variant="body2" 
  sx={{ ...theme.typography.Inter500, fontSize: "16px" }} 
  color="textSecondary" 
  mb={1}
>
  {product.description.length > 50 
    ? `${product.description.substring(0, 50)}...` 
    : product.description}
</Typography>

   <Typography 
                   sx={{ 
                     ...theme.typography.urbanist800, 
                     fontSize: "32px", 
                     color: "#F6A704" 
                   }}
                 >
                   ₦{new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 }).format(product.price)}
                 </Typography>

  <Box display="flex" alignItems="center" mt={1}>
    <LocationOnIcon fontSize="small" color="action" />
    <Typography variant="body2" sx={{ ...theme.typography.Inter400, fontSize: "16px" }} color="textSecondary" ml={0.5}>
      {product.location}
    </Typography>
  </Box>

  {/* Centering the Button */}
  <Box display="flex" justifyContent="center" width="100%" mt={2}>
  {product.availability === "Expired" ? (
    <Button
      sx={{
        bgcolor: "#5604F6",
        color: "white",
        gap: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "9999px",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        ...theme.typography.urbanist600,
        padding: { xs: "6px 12px", sm: "10px 20px", md: "6px 40px" },
        textTransform: "none",
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          bgcolor: "#4503D6",
        },
      }}
      onClick={() => handleEditProducts(product)}  
    >
     Renew Product
     <ArrowForwardIosIcon fontSize="small" sx={{ ml: 1 }} />
    </Button>
  ) : (
    <Button
      sx={{
        bgcolor: "#5604F6",
        color: "white",
        gap: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "9999px",
        fontSize: { xs: "12px", sm: "14px", md: "16px" },
        ...theme.typography.urbanist600,
        padding: { xs: "6px 12px", sm: "10px 20px", md: "6px 24px" },
        textTransform: "none",
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          bgcolor: "#4503D6",
        },
      }}
     
    >
       Active 
      
    </Button>
  )}
</Box>

</CardContent>

            </Card>
         
          </Grid>
        ))
      ) : (
        <Typography variant="body1" color="textSecondary" sx={{ m: 2 }}>
          No products found.
        </Typography>
      )}

      {/* Menu Modal */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
  <MenuItem onClick={handleEditProduct}>Edit Product</MenuItem>
  <MenuItem onClick={handlePromoteProduct}>Promote Product</MenuItem>
  <MenuItem
   onClick={handleDeleteProduct}
  >
    Delete Product
  </MenuItem>
</Menu>;
    </Grid>



    </Container>
  );
};

export default ProductGrid;


